import "./index.css"

export default function() {
    if (!customElements.get('jky-selectopen')) {
        customElements.define(
            'jky-selectopen',
            class JkySelectOpen extends HTMLElement {
                constructor() {
                    super();
                    this.init();
                }
                init() {

                }
            }
        )
    }

    if (!customElements.get('jky-checkbox')) {
        customElements.define(
            'jky-checkbox',
            class JkyCheckbox extends HTMLElement {
                constructor() {
                    super();
                    this.input = this.querySelector(".jky-checkbox-original");
                    this.init();
                }
                init() {
                    this.input && this.input.addEventListener("change", () => {
                        if(this.input.checked) {
                            this.setAttribute("data-value", this.input.getAttribute("data-value"));
                        } else {
                            this.removeAttribute("data-value");
                        }
                    })
                }
            }
        )
    }

    if (!customElements.get('jky-qty-select')) {
        customElements.define(
            'jky-qty-select',
            class JkyQtySelectOpen extends HTMLElement {
                constructor() {
                    super();
                    this.input = this.querySelector(".jky_quantity__input");
                    this.changeEvent = new Event('change', { bubbles: true });
                    this.input.addEventListener('change', this.onInputChange.bind(this));
                    this.plusButton = this.querySelector(".jky_quantity__button[name='plus']");
                    this.minusButton = this.querySelector(".jky_quantity__button[name='minus']");
                    this.init();
                }
                onInputChange(event) {
                    this.validateQtyRules();
                }

                onButtonClick(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    const previousValue = this.input.value;

                    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
                    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
                }

                init() {
                    this.plusButton.addEventListener("click", () => {
                        event.preventDefault();
                        const previousValue = this.input.value;
                        this.input.stepUp();
                        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
                    })

                    this.minusButton.addEventListener("click", () => {
                        event.preventDefault();
                        const previousValue = this.input.value;
                        this.input.stepDown();
                        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
                    })
                }

                validateQtyRules() {
                    const value = parseInt(this.input.value);
                    if (this.input.min) {
                        const min = parseInt(this.input.min);
                        const buttonMinus = this.querySelector(".jky_quantity__button[name='minus']");
                        buttonMinus.classList.toggle('disabled', value <= min);
                    }
                    if (this.input.max) {
                        const max = parseInt(this.input.max);
                        const buttonPlus = this.querySelector(".jky_quantity__button[name='plus']");
                        buttonPlus.classList.toggle('disabled', value >= max);
                    }

                    if(value <= 0 || isNaN(value) || Number(value) % 1 !== 0) {
                        this.input.value = 1;
                    }
                }
            }
        )
    }

    if (!customElements.get('jky-drop-menu')) {
        customElements.define(
            'jky-drop-menu',
            class JkyDropmenu extends HTMLElement {
                constructor() {
                    super();
                    this.input = this.querySelector(".jky_drop_menu_field input");
                    this.options = this.querySelectorAll(".list-menu--disclosure li");
                    this.details = this.querySelector("details")

                    this.init();
                }
                init() {
                    for(let i = 0; i < this.options.length; i++) {
                        const target = this.options[i];
                        target.addEventListener("click", () => {
                            const label = target.getAttribute("data-label");
                            const value = target.getAttribute("data-key");
                            this.input.value = label;
                            this.setAttribute("data-value", value);
                            this.details.removeAttribute("open");
                        })
                    }
                }
            }
        )
    }

    if (!customElements.get('jky-phoneselect')) {
        customElements.define(
            'jky-phoneselect',
            class JkyPhoneselect extends HTMLElement {
                constructor() {
                    super();
                    this.activeIso = Shopify?.country || "US";
                    this.input = this.querySelector('.form-item>input');
                    this.flag = this.querySelector(".phone_select_prefix_flag");
                    this.country = this.querySelector(".phone_select_prefix_country");
                    this.code = this.querySelector(".phone_select_prefix_code");
                    this.searchInput = this.querySelector(".phone_select_search_wrapper input");

                    this.countriesItem = this.querySelectorAll(".phone_select_country_item");
                    this.countryContainer = this.querySelector(".phone_select_country_container");
                    this.menuDetail = this.querySelector("details-disclosure details");
                    this.input = this.querySelector(".form-item_phone_select>input")
                    this.init();
                }
                async init() {
                    this.list = await this.getGlobalISO();
                    this.renderInit();
                    this.renderMenu(this.list);

                    this.searchInput.addEventListener("input", () => {
                        const keyword = this.searchInput.value.trim().toLocaleLowerCase() || "";
                        let res = [];
                        res = this.list.filter(i => {
                            return i.country.toLocaleLowerCase().indexOf(keyword) !== -1 || i.iso.toLocaleLowerCase().indexOf(
                                keyword) !== -1
                        })
                        this.renderMenu(res)
                    })

                    this.input.addEventListener("input", () => {
                        this.setAttribute("data-value", this.input.value.trim())
                    })
                }
                async getGlobalISO() {
                    try {
                        const response = await fetch('https://cdn.shopify.com/s/files/1/0550/0524/9633/files/global_iso.json?v=1702862314');
                        if (!response.ok) {
                            throw new Error('请求失败');
                        }
                        const data = await response.json();
                        return data;
                    } catch(error) {
                        console.error(error);
                        return [];
                    }
                }
                renderMenu(list) {
                    this.countryContainer.innerHTML = '';
                    let list_dom = ''
                    if (list.length === 0) {
                        list_dom = `<div class="no-data text-center" data-code="" data-iso="" data-cr="">No Search Data</div>`
                    } else {
                        list.forEach(i => {
                            list_dom += `<li class="${this.activeIso === i.iso ? 'phone_select_country_item active':'phone_select_country_item'}" data-code="${i.code}" data-cr="${i.iso}" data-iso="${i.iso}">${i.country}</li>`
                        })
                    }
                    this.countryContainer.innerHTML = list_dom;
                    this.countriesItem = this.querySelectorAll(".phone_select_country_item");

                    for(let i = 0; i < this.countriesItem.length; i++) {
                        this.countriesItem[i].addEventListener("click", (e) => {
                            this.countriesItem.forEach(function(node) {
                                node.classList.remove('active');
                            });
                            this.countriesItem[i].classList.add("active");
                            const code = e.target.getAttribute("data-code");
                            const iso = e.target.getAttribute("data-iso");
                            this.country.innerText = iso
                            this.code.innerText = code
                            this.flag.src = `https://cdn.shopify.com/static/images/flags/${iso.toLowerCase()}.svg?width=32`
                            this.activeIso = iso;
                            this.menuDetail.removeAttribute("open");
                            this.setAttribute("data-iso", code)
                            this.setAttribute("data-cr", iso)
                        })
                    }
                }
                renderInit() {
                    const activeCountry = this.list.filter(i => i.iso === this.activeIso)
                    if (activeCountry.length > 0) {
                        const options = {
                            iso: activeCountry[0].iso || "",
                            flag: activeCountry[0].iso ?
                                `https://cdn.shopify.com/static/images/flags/${activeCountry[0].iso.toLowerCase()}.svg?width=32` : "",
                            code: activeCountry[0].code || ""
                        }
                        this.country.innerText = options.iso
                        this.code.innerText = options.code
                        this.flag.src = `https://cdn.shopify.com/static/images/flags/${options.iso.toLowerCase()}.svg?width=32`
                        this.activeIso = options.iso;
                        this.setAttribute("data-iso", options.code)
                        this.setAttribute("data-cr", options.iso)
                    }
                }
            }
        )
    }

    if (!customElements.get('jky-form')) {
        customElements.define(
            'jky-form',
            class JkyForm extends HTMLElement {
                constructor() {
                    super();
                    this.form = this.querySelector("form");
                    this.allValidFields = this.querySelectorAll(".form-item.required:not(.remove-form)");
                    this.allFields = this.querySelectorAll(".form-item:not(.remove-form)");
                    this.formPrams = {}
                    this.before_fb_success = true
                    // Form submit
                    this.querySelector(".form_sub_btn").addEventListener("click", async (e) => {
                        e.preventDefault();
                        this.formValidate();
                        this.handleFormValue();
                        const hasErrorTips = this.querySelector(".field_error-tips");
                        if(this.querySelector(".form-item.error")|| hasErrorTips) {
                            console.info("form params error");
                        } else { // 提交表单
                            let {BASE_URL, CR, lang} = this.getFecthConfig();
                            const action = this.getFetchUrl();
                            //修复订阅接口日本lang不对
                            if( action=='/osconsumerapi/v1/notice/subscribe' && lang=='ja'){
                                lang ='jp'
                            }

                            if(this.formPrams.email && this.formPrams.phone){
                                this.formPrams.tags="FOOT-Email-Subcribe,FOOT-Tel-Subcribe"
                            }
                            this.querySelector(".form_sub_btn").classList.add("loading");
                            const extras_params = this.getExtraParams()

                            // 表单提交前回调(函数 && returen Promise)
                            if(!!this.beforeFb && typeof this.beforeFb === 'function') {
                                try {
                                    await this.beforeFb({...this.formPrams, shopShopifyId: shopId, ...extras_params, shopify_shop_id: shopId}).then(res => {
                                        this.before_fb_success = true
                                    })
                                    .catch(e => {
                                        this.before_fb_success = false
                                    })
                                } catch (error) {console.log("error", error)}
                            }
                            if(!this.before_fb_success) return

                            fetch(`${BASE_URL}${action}`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json', lang, cr: CR
                                },
                                body: JSON.stringify({...this.formPrams, shopShopifyId: shopId, ...extras_params, shopify_shop_id: shopId})
                            }).then(response => response.json())
                                .then(data => {
                                    this.querySelector(".form_sub_btn").classList.remove("loading")

                                    if(data && data.code === 200) {
                                        // 表单提交回调 - 回调函数外部自定义
                                        const cb = eval( this.getAttribute( 'onsubmitcall' ) );
                                        if(cb && typeof cb === "function") {
                                            cb({...this.formPrams, response: data, ...extras_params});
                                        } else {
                                            pushSuccessMessage(`${data.message}`);
                                        }

                                        this.handleRest();
                                        if(!!this.afterFb && typeof this.afterFb === 'function') { // 成功回调
                                            this.afterFb(data)
                                        }
                                    } else {
                                        pushErrorMessage(`${data.message}`);
                                    }
                                })
                                .catch((e) => {
                                    this.querySelector(".form_sub_btn").classList.remove("loading")
                                    pushErrorMessage(`${e.message}`);
                                })
                        }
                    })

                    // 表单重置
                    this.querySelector(".form_rest") && this.querySelector(".form_rest").addEventListener("click", (e) => {
                        e.preventDefault();
                        this.handleRest();
                    })

                    this.bindValidateField();
                }

                init() {
                    this.formValidate();
                }

                // 表单循环校验
                formValidate() {
                    this.hasError = false;
                    for(let i = 0; i < this.allValidFields.length; i++) {
                        const field = this.allValidFields[i];
                        const field_type = field.getAttribute("data-field");
                        switch (field_type) {
                            case 'input':
                                const input = field.querySelector("input");
                                if(input.value) {
                                    this.handleRemoveError(field);
                                    const regType = input.getAttribute("data-reg");
                                    const regText = input.getAttribute("data-regerror");
                                    this.handleRegValidate(regType, input.value, regText, field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, input.getAttribute("data-error"));
                                }
                                break;
                            case 'phone_input':
                                const phoneselect = field.querySelector("jky-phoneselect");
                                const phoneInput = phoneselect.querySelector("input")
                                if(phoneselect.getAttribute("data-value")) {
                                    this.handleRemoveError(field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, phoneInput.getAttribute("data-error"))
                                }
                                break;
                            case 'open_drop':
                                const dropOptions = field.querySelectorAll("jky-checkbox");
                                const hasSelected = Array.from(dropOptions).some(item => item.getAttribute("data-value"));
                                const open_drop_dom = field.querySelector("jky-select-open");
                                if(hasSelected) {
                                    this.handleRemoveError(field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, open_drop_dom.getAttribute("data-error"))
                                }
                                break;
                            case 'dropmenu':
                                const dropmenuField = field.querySelector("jky-drop-menu");
                                if(dropmenuField.getAttribute("data-value")) {
                                    this.handleRemoveError(field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, dropmenuField.getAttribute("data-error"));
                                }
                                break;
                            case 'check_box':
                                const checkboxField = field.querySelector("jky-checkbox");
                                if(checkboxField.getAttribute("data-value")) {
                                    this.handleRemoveError(field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, field.getAttribute("data-error"));
                                }
                                break;
                            case 'radio':
                                const selectedRadio = field.querySelector('input[type="radio"]:checked');
                                if(selectedRadio) {
                                    this.handleRemoveError(field);
                                } else {
                                    this.hasError = true;
                                    this.handleErrorMsg(field, field.getAttribute("data-error"));
                                }
                                break;
                            default:
                                this.hasError = true;
                                break;
                        }
                    }
                    const notscroll = this.getScroll();
                    if (!notscroll) {
                        this.scrollToTop(this.querySelector(".form-item.error"));
                    }
                    if(this.hasError) return


                    // open_drop类型 extra input必填校验
                    if(this.querySelectorAll("jky-select-open[data-showinput='true']").length > 0) {
                        for(let i = 0; i < this.querySelectorAll("jky-select-open[data-showinput='true']").length; i++) {
                            const field = this.querySelectorAll("jky-select-open[data-showinput='true']")[i];
                            const _res = this.mutilSelectInputValit(field)
                            if(_res === false) {
                                this.hasError = true;
                                this.scrollToTop(field);
                                return
                            }
                        }
                    }
                    this.scrollToTop(this.querySelector(".form-item.error"));
                }

                // 表单域校验绑定校验事件
                bindValidateField() {
                    for(let i = 0; i < this.allValidFields.length; i++) {
                        const field = this.allValidFields[i];
                        const field_type = field.getAttribute("data-field");
                        switch (field_type) {
                            case 'input':
                                const input = field.querySelector("input");
                                input.addEventListener("input", () => {
                                    if(input.value) {
                                        this.handleRemoveError(field);
                                        const regType = input.getAttribute("data-reg");
                                        const regText = input.getAttribute("data-regerror");
                                        this.handleRegValidate(regType, input.value, regText, field);
                                    } else {
                                        this.handleErrorMsg(field, input.getAttribute("data-error"))
                                    }
                                })
                                break;
                            case 'phone_input':
                                const phoneInput = field.querySelector("jky-phoneselect input");
                                phoneInput.addEventListener("input", () => {
                                    if(phoneInput.value) {
                                        this.handleRemoveError(field);
                                    } else {
                                        this.handleErrorMsg(field, phoneInput.getAttribute("data-error"))
                                    }
                                })
                                break;
                            case 'open_drop':
                                const dropOptions = field.querySelectorAll("jky-checkbox");
                                const open_drop_error = field.querySelector("jky-select-open").getAttribute("data-error");
                                const isInput =  field.querySelector("jky-select-open").getAttribute("data-showinput") === "true";

                                Array.from(dropOptions).forEach((item) => {
                                    item.addEventListener("click", (e) => {
                                        setTimeout(() => {

                                            e.stopPropagation();
                                            const dropOptions_field = field.querySelectorAll("jky-checkbox");
                                            const hasSelected = Array.from(dropOptions_field).some(item => item.getAttribute("data-value"));

                                            if(hasSelected) {
                                                this.handleRemoveError(field);
                                            } else {
                                                this.handleErrorMsg(field, open_drop_error);
                                            }

                                            if(isInput) { // 额外input - 需要勾选后显示input
                                                $(field).find('jky-checkbox').siblings().removeClass("active")
                                                $(field).find('jky-checkbox[data-value]').siblings().addClass("active")
                                                $(field).find('jky-checkbox[data-value]').siblings().bind("input", () => {
                                                    this.mutilSelectInputValit(field);
                                                })
                                            }
                                        }, 10);
                                    })
                                })

                                break;
                            case 'dropmenu':
                                const dropmenuDom = field.querySelector("jky-drop-menu");
                                const dropItems = field.querySelectorAll(".list-menu--disclosure li");
                                Array.from(dropItems).forEach(item => {
                                    item.addEventListener("click", (e) => {
                                        setTimeout(() => {
                                            e.stopPropagation();
                                            if(dropmenuDom.getAttribute("data-value")) {
                                                this.handleRemoveError(field);
                                            } else {
                                                this.handleErrorMsg(field, dropmenuDom.getAttribute("data-error"));
                                            }
                                        }, 10);
                                    })
                                })
                                break;
                            case 'check_box':
                                const checkboxField = field.querySelector("jky-checkbox");
                                const checkboxField_input = field.querySelector("input");
                                checkboxField_input.addEventListener("change", (e) => {
                                    e.stopPropagation();

                                    // FIX: 未知原因，无法准确获取data-value
                                    setTimeout(() => {
                                        if(checkboxField.getAttribute("data-value")) {
                                            this.handleRemoveError(field);
                                        } else {
                                            this.handleErrorMsg(field, field.getAttribute("data-error"));
                                        }
                                    }, 0);
                                })
                                break;
                            case 'radio':
                                const selectedRadio = field.querySelector('input[type="radio"]:checked');
                                const radios = field.querySelectorAll('input[type="radio"]');

                                radios.forEach(radio => {
                                    radio.addEventListener('change', event => {
                                        const selectedValue = event.target.value;
                                        this.handleRemoveError(field);
                                    });
                                });
                                break;
                            default:
                                break;
                        }
                    }
                }

                // 错误提示
                handleErrorMsg(field, error_text) {
                    field.classList.add("error");
                    if(error_text && !field.querySelector(".field_error-tips")) {
                        const error_dom = document.createElement('div');
                        error_dom.classList.add('field_error-tips');
                        error_dom.innerText = error_text;
                        field.appendChild(error_dom);
                    }
                }

                // 移除错误
                handleRemoveError(field) {
                    field.classList.remove("error");
                    const fieldError = field.querySelector(".field_error-tips");
                    if(fieldError) field.removeChild(fieldError);
                }

                // 校验成功获取form表单字段信息
                handleFormValue() {
                    this.allValidFields = this.querySelectorAll(".form-item.required:not(.remove-form)");
                    this.allFields = this.querySelectorAll(".form-item:not(.remove-form)");
                    for(let i = 0; i < this.allFields.length; i++) {
                        const field = this.allFields[i];
                        const field_type = field.getAttribute("data-field");

                        switch (field_type) {
                            case 'input':
                                const input = field.querySelector("input");
                                const input_key = input.getAttribute("data-value") || `field_${i}`;
                                if(!input_key) break;
                                this.formPrams[input_key] = input.value;
                                break;
                            case 'phone_input': // phone + cr
                                const jky_phone_input = field.querySelector("jky-phoneselect");
                                const phoneInput = field.querySelector("jky-phoneselect input");
                                const phoneInput_key = phoneInput.getAttribute("data-value");
                                if(!phoneInput_key) break;
                                this.formPrams[phoneInput_key] = `${phoneInput.value}`;
                                this.formPrams["phoneCr"] = `${jky_phone_input.getAttribute("data-cr")}`;
                                this.formPrams["phone_cr"] = `${jky_phone_input.getAttribute("data-cr")}`;
                                break;
                            case 'open_drop':
                                const dropOptions = field.querySelectorAll("jky-checkbox");
                                const open_drop_key = field.querySelector("jky-select-open").getAttribute("data-value") || `field_${i}`;
                                const isQty = field.querySelector("jky-select-open").getAttribute("data-showqty") === "true";
                                const isInput = field.querySelector("jky-select-open").getAttribute("data-showinput") === "true";

                                if(!open_drop_key) break

                                let slected_open_drop
                                if(isQty) { // checkbox 带数字选择
                                    const items = field.querySelectorAll(".jky-option-item");
                                    const checked = Array.from(items).filter(item => item.querySelector("jky-checkbox").getAttribute("data-value"))
                                    slected_open_drop = checked.map(t => {
                                        return {
                                            title: t.querySelector("jky-checkbox").getAttribute("data-value"),
                                            quantity: t.querySelector("jky-qty-select input").value
                                        }
                                    })
                                } else if(isInput) { // input
                                    const items = field.querySelectorAll(".jky-option-item");
                                    const checked = Array.from(items).filter(item => item.querySelector("jky-checkbox").getAttribute("data-value"));

                                    slected_open_drop = checked.map(t => {
                                        return {
                                            name: t.querySelector("jky-checkbox").getAttribute("data-value"),
                                            value: t.querySelector(".jky-selectopen_extra_input").value
                                        }
                                    })
                                } else { // 默认
                                    slected_open_drop = Array.from(dropOptions).map(dropOption_item => dropOption_item.getAttribute("data-value")).filter(item => item);
                                }

                                this.formPrams[open_drop_key] = slected_open_drop;
                                break;
                            case 'dropmenu':
                                const dropmenuDom = field.querySelector("jky-drop-menu");
                                const dropmenuInput = field.querySelector("jky-drop-menu summary input");
                                const dropmenu_key = dropmenuInput.getAttribute("data-value") || `field_${i}`;
                                if(!dropmenu_key) break;
                                this.formPrams[dropmenu_key] = dropmenuDom.getAttribute("data-value");
                                break;
                            case 'check_box':
                                const checkboxField = field.querySelector("jky-checkbox");
                                const checkboxField_input = field.querySelector("jky-checkbox input");
                                const checkbox_key = checkboxField_input.getAttribute("data-value") || `field_${i}`;
                                if(!checkbox_key) break
                                this.formPrams[checkbox_key] = !!checkboxField.getAttribute("data-value");
                                break;
                            case 'radio':
                                const selectedRadio = field.querySelector('input[type="radio"]:checked');
                                const radio_key = field.getAttribute("data-value") || `field_${i}`;
                                if(!radio_key) break
                                this.formPrams[radio_key] = selectedRadio.value;
                                break;
                            default:
                                break;
                        }
                    }
                }

                // 指定规则校验
                handleRegValidate(regType, value, regError, field) {
                    let isright = true
                    switch (regType) {
                        case 'email':
                            isright = value.indexOf("@") !== -1;
                            break;
                        case 'number':
                            isright = /^[0-9]+$/.test(value);
                            break;
                        case 'phone':
                            // e.164 格式
                            isright = /^\+?[1-9]\d{1,14}$/.test(value);
                            break;
                        default:
                            isright = true
                            break;
                    }

                    if(!isright) {
                        this.hasError = true;
                        if(!field.querySelector(".field_error-tips")) {
                            const error_dom = document.createElement('div');
                            error_dom.classList.add('field_error-tips');
                            error_dom.innerText = regError;
                            field.appendChild(error_dom);
                        } else {
                            field.querySelector(".field_error-tips").innerText = regError;
                        }
                    }
                }

                // reset - 重置表单
                handleRest() {
                    $(this).find(".form-item").removeClass("error");
                    $(this).find(".form-item .field_error-tips").remove();

                    // input类型重置 form-item_const 固定参数（不需要重置）
                    $(this).find(".form-item:not(.form-item_const)[data-field='input'] input").val("");

                    // phone input类型重置
                    $(this).find("jky-phoneselect").removeAttr("data-value");
                    $(this).find("jky-phoneselect input").val("");

                    // open_drop类型 extra 重置
                    $(this).find("jky-select-open jky-checkbox").removeAttr("data-value");
                    $(this).find("jky-select-open jky-checkbox .jky-checkbox-original").prop('checked', false);
                    $(this).find(".jky-selectopen_extra_input").val("").removeClass("active").removeClass("error");
                    $(this).find("jky-qty-select input").val(1);

                    // dropmenu类型重置
                    $(this).find("jky-drop-menu").removeAttr("data-value");
                    $(this).find("jky-drop-menu .jky_drop_menu_field input").val("");

                    // check_box类型重置
                    $(this).find(".form-item[data-field='check_box'] jky-checkbox").removeAttr("data-value");
                    $(this).find(".form-item[data-field='check_box'] jky-checkbox .jky-checkbox-original").prop('checked', false);

                    // radio类型重置 (radio不重置避免联动)
                    // $(this).find(".form-item[data-field='radio'] input").prop('checked', false);
                    this.formPrams = {}
                }

                // 指定元素 滚动到顶部
                scrollToTop(element, distance = 200) {
                    if(this.getAttribute("data-scroll") == "false") return
                    if(!element) return;
                    const rect = element.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const targetPosition = rect.top + scrollTop - distance;
                    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                }

                // 特殊校验 - open_drop类型 extra input必填校验
                mutilSelectInputValit(field) {
                    $(field).find('jky-checkbox[data-value]').siblings().removeClass("error");
                    const emptyInputs = $(field).find('jky-checkbox[data-value]').siblings().filter(function() {
                        if($(this).val() === '') $(this).addClass("error");
                        return $(this).val().trim() === '';
                    });
                    if(emptyInputs.length > 0) {
                        this.handleErrorMsg(field, "");
                        return false
                    } else {
                        this.handleRemoveError(field);
                    }
                }

                // 获取请求基本信息lang cr baseurl
                getFecthConfig() {
                    let BASE_URL = '';
                    const prodUrl = "https://api.myjackery.com"
                    const uatUrl = "https://api-uat.myjackery.com"
                    const devUrl = "https://demo-api.myjackery.com"

                    switch (pageInfo?.env) {
                        case "prod": BASE_URL = prodUrl; break;
                        case "demo": BASE_URL = devUrl; break;
                        case "uat": BASE_URL = uatUrl; break;
                        default: BASE_URL = prodUrl; break;
                    }
                    return {BASE_URL, CR: pageInfo?.cr || 'US', lang: pageInfo?.lang || 'en'}
                }

                // 获取请求额外信息
                getExtraParams() {
                    const extras = this.querySelector("form").getAttribute("data-extras")
                    if(!extras) return {}

                    try {
                        const obj = {}
                        extras.split("&&").forEach(item => {
                            if(item.split(":")[0]) {
                                obj[item.split(":")[0]] = item.split(":")[1]
                            }
                        })
                        return obj
                    } catch (error) {
                        console.error("extra params Format error");
                        return {}
                    }
                }

                // 获取form url
                getFetchUrl() {
                    const url = this.querySelector("form").getAttribute("data-action")
                    if(!url) {
                        console.error("form builder init error: no action url")
                        return
                    }
                    return url
                }

                //获取是否滚动
                getScroll() {
                    const notscroll = this.querySelector("form").getAttribute("data-notscroll")
                    return notscroll
                }
            }
        )
    }
}
